import React from "react";
import AnimateCC from "../../../animate";
import { AbcMenu } from "../AbcMenu";
import { CakeGame } from "./CakeGame";
import { additionalSounds } from "./CakeSounds";

const CakeComponent: React.FC<{
    frame: AbcMenu;
}> = ({ frame }) => {
    const game = React.useRef(new CakeGame(frame));

    return (
        <AnimateCC
            base="/lunapark/abc/cake"
            animationName="cake"
            scale={0.8}
            shiftX={125}
            shiftY={100}
            onLoaded={game.current.loaded}
            changeFramerate={true}
            additionalSounds={additionalSounds}
        />
    );
};
export default CakeComponent;
